module.exports = __webpack_public_path__ + "img/1.99750129.png";